import React from 'react';

const Contact = () => {
  return (
    <div className="page-wrapper">
      <section className="page-header">
        <div className="header-container">
          <h1 className="page-title">Contact Us</h1>
          <p className="page-subtitle">
            Get in touch with our team
          </p>
        </div>
      </section>

      <section className="contact-intake-section" id="contact">
        <div className="contact-intake-container">
          <h2 className="contact-intake-title">Ready for Tailored Strategic Insights?</h2>
          
          <p className="contact-intake-description">
            Complete this quick intake form to share your goals, challenges, and preferred service. 
            We'll review your submission and reach out within 48 hours to discuss next steps.
          </p>

          {/* Jotform Embed */}
          <div className="jotform-wrapper">
            <iframe
              id="JotFormIFrame-260092293338155"
              title="New Client Information Form"
              allowTransparency="true"
              allow="geolocation; microphone; camera; fullscreen; payment"
              src="https://form.jotform.com/260092293338155"
              frameBorder="0"
              style={{
                width: '100%',
                height: '900px',
                border: 'none'
              }}
            />
          </div>

          {/* Optional fallback email note */}
          <p className="contact-fallback">
            Prefer direct email? Reach out at{' '}
            <a href="mailto:info@arcacapitalis.com" className="contact-fallback-link">
              info@arcacapitalis.com
            </a>
          </p>
        </div>
      </section>
    </div>
  );
};

export default Contact;